import type { IconData } from '@stacksjs/iconify-core'

export const mediaStop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M408 80H104a24.027 24.027 0 0 0-24 24v304a24.027 24.027 0 0 0 24 24h304a24.027 24.027 0 0 0 24-24V104a24.027 24.027 0 0 0-24-24m-8 320H112V112h288Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mediaStop
